import { getEnv } from '@unni/platform'

export function getStaticGoogleMapURL(options: {
  lat: number
  lng: number
  width: number
  height: number
  zoom?: number
  markerColor?: string
  locale?: string
}): string {
  const KEY = getEnv('NEXT_PUBLIC_GOOGLE_MAP_API_KEY')
  const SOLAR_API_HOST = getEnv('NEXT_PUBLIC_SOLAR_API_HOST')

  // Fallback handling for SSR environments where env vars might be undefined
  if (!SOLAR_API_HOST) {
    console.warn('NEXT_PUBLIC_SOLAR_API_HOST is not available, falling back to empty string')
    return ''
  }

  const gMapURL = new URL(`${SOLAR_API_HOST}/authentication/map/queries/get-generated-signed-map-url`)
  const { lat, lng, width: w, height: h } = options
  const zoom = options.zoom || 15
  const color = '0xFF540F'

  const params = new URLSearchParams({
    scale: '2',
    center: `${lat},${lng}`,
    zoom: zoom.toString(),
    size: `${w}x${h}`,
    maptype: 'roadmap',
    markers: `color:${color}|${lat},${lng}`,
    key: KEY,
    language: options.locale || 'ko-KR',
  })

  gMapURL.search = params.toString()
  return gMapURL.href
}
